import Vue from "vue";
import VueRouter from "vue-router";
import auth from "../auth/auth.js";

import Inicio from "../components/inicio/Inicio.vue";
import Login from "../components/login/Login.vue";
import ForgotPassword from "../components/login/ForgotPassword.vue";
import ResetPassword from "../components/login/ResetPassword.vue";

import rutas_usuarios from "../modulos/usuarios/rutas/rutas_usuarios.js";
import rutas_productos from "../modulos/productos/rutas/rutas_productos.js";
import rutas_agentes from "../modulos/agentes/rutas/rutas_agentes.js";
import rutas_clientes from "../modulos/clientes/rutas/rutas_clientes.js";
import rutas_presupuesto from "../modulos/presupuesto/rutas/rutas_presupuesto.js";
import rutas_contrato from "../modulos/contrato/rutas/rutas_contrato.js";
import rutas_planificaciones from "../modulos/planificaciones/rutas/rutas_planificaciones.js";
import rutas_seguimiento from "../modulos/seguimiento/rutas/rutas_seguimiento.js";
import rutas_pedidos from "../modulos/pedidos/rutas/rutas_pedidos.js";
import rutas_factura from "../modulos/factura/rutas/rutas_factura.js";
import rutas_sociedades from "../modulos/sociedades/rutas/rutas_sociedades.js";
import rutas_proveedores from "../modulos/proveedores/rutas/rutas_proveedores.js";
import rutas_pedidos_proveedores from "../modulos/PedidoProveedor/rutas/rutas_pedido_proveedor.js";
import rutas_albaranes from "../modulos/albaranes/rutas/rutas_albaranes.js";
import rutas_ordenes from "../modulos/ordenesTrabajo/rutas/rutas_ordenes.js";
import rutas_equipo from "../modulos/equipo/rutas/rutas_equipo";
import ListaUsuarios from "../modulos/usuarios/componentes/ListaUsuarios.vue";
import ListaKm from "../modulos/CalculoKm/rutas/rutas_km.js";
import rutas_planificaciones_orden from "../modulos/planificacionOrden/rutas/rutas_plan.js";
import rutas_productos_interes from "../modulos/productosInteres/rutas/rutas_productos.js";
import rutas_fichaje from "../modulos/fichajes/rutas/rutas_fichajes.js";
import rutas_clientes_conocidos from "../modulos/clientesConocidos/rutas/rutas_clientes_conocidos.js";
import rutas_controller from "../modulos/Controller/rutas/rutas_controller.js";
import rutas_libro_diario from "../modulos/libroDiario/rutas/rutas_libro_diario.js";
import rutas_reporte_iva from "../modulos/reporteIva/rutas/rutas_reporte_iva.js";
import rutas_cierre_orden from "../modulos/cierre_orden/rutas/rutas_cierre_orden.js";
import rutas_peticiones from "../modulos/peticiones/rutas/rutas_peticiones.js"
import rutas_facturacion from "../modulos/facturacion/rutas/rutas_facturacion.js"
import rutas_pagos from '../modulos/pagos/rutas/rutas_pagos.js'
import rutas_albaran_venta from "../modulos/albaran_venta/rutas/rutas_albaran_venta.js"
Vue.use(VueRouter);

/* importar rutas */

const base_routes = [
    ...route("/login", Login),
    ...route("/forgot", ForgotPassword),
    ...route("/reset-password", ResetPassword),

    ...route("/", Inicio, {
        Auth: true,
    }),
    ...route("/lista-usuario", ListaUsuarios, {
        Auth: true,
        // req_admin: true,
    }),
];

const routes = [
    ...base_routes,
    ...rutas_usuarios,
    ...rutas_productos,
    ...rutas_agentes,
    ...rutas_clientes,
    ...rutas_presupuesto,
    ...rutas_contrato,
    ...rutas_planificaciones,
    ...rutas_seguimiento,
    ...rutas_pedidos,
    ...rutas_factura,
    ...rutas_sociedades,
    ...rutas_proveedores,
    ...rutas_pedidos_proveedores,
    ...rutas_albaranes,
    ...rutas_ordenes,
    ...ListaKm,
    ...rutas_equipo,
    ...rutas_planificaciones_orden,
    ...rutas_productos_interes,
    ...rutas_clientes_conocidos,
    ...rutas_fichaje,
    ...rutas_controller,
    ...rutas_libro_diario,
    ...rutas_reporte_iva,
    ...rutas_cierre_orden,
    ...rutas_peticiones,
    ...rutas_facturacion,
    ...rutas_pagos,
    ...rutas_albaran_venta,
];

const router = new VueRouter({
    routes,
});

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

router.beforeEach((to, from, next) => {
    if ((to.path == "/login") & auth.authenticated()) {
        next({
            path: "/",
            query: {
                redirect: to.fullPath,
            },
        });
    }

    if (to.meta.Auth) {
        const authUser = localStorage.getItem("role");
        if (!auth.authenticated()) {
            next({
                path: "/login",
                query: {
                    redirect: to.fullPath,
                },
            });
        } else if (to.meta.roles != null) {
            console.log(to.meta.roles);
            to.meta.roles.includes(localStorage.getItem("role"))
                ? next()
                : next("/");
        } else if (to.meta.req_admin) {
           ( authUser == 1 || authUser == 9 || authUser == 14)? next() : next("/");
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
